import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Link from '../Global/Link';
import HutchLogo from '../../../static/images/hutch_logo_white.png';

import SlashBlack from '../../../static/images/slash-black-top.svg';
import SlashBlue from '../../../static/images/slash-blue-top.svg';
import SlashRed from '../../../static/images/slash-red-top.svg';
import SlashGreen from '../../../static/images/slash-green-top.svg';
import SlashPink from '../../../static/images/slash-pink-top.svg';
import SlashYellow from '../../../static/images/slash-yellow-top.svg';
import SlashBlackBottom from '../../../static/images/slash-black-bottom.svg';
import SlashBlueBottom from '../../../static/images/slash-blue-bottom.svg';
import SlashRedBottom from '../../../static/images/slash-red-bottom.svg';
import SlashGreenBottom from '../../../static/images/slash-green-bottom.svg';
import SlashPinkBottom from '../../../static/images/slash-pink-bottom.svg';
import SlashYellowBottom from '../../../static/images/slash-yellow-bottom.svg';

const ColorSwitcher = (colour) => {
  switch (colour) {
    case 'black':
      return { top: SlashBlack, bottom: SlashBlackBottom };
    case 'red':
      return { top: SlashRed, bottom: SlashRedBottom };
    case 'yellow':
      return { top: SlashYellow, bottom: SlashYellowBottom };
    case 'green':
      return { top: SlashGreen, bottom: SlashGreenBottom };
    case 'pink':
      return { top: SlashPink, bottom: SlashPinkBottom };
    case 'blue':
      return { top: SlashBlue, bottom: SlashBlueBottom };
    default:
      return { top: SlashBlack, bottom: SlashBlackBottom };
  }
};

// ====

function toggleMenu(status) {
  if (status === false) {
    // Do something
  } else if (status === true) {
    // Do something else
  }
}

const Header = (props) => {
  const { settings, background, mode } = props;
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);
  useEffect(() => {
    toggleMenu(menuOpen);
  });

  // Site has the pages in it!
  return (
    <header
      className={`brand-header ${menuOpen === true && 'brand-header-open'}`}
    >
      <nav className="brand-navbar p-3 brand-font">
        <a className="brand-logo" href="/">
          <img src={HutchLogo} alt="Hutch" className="brand-logo-image" />
        </a>

        <button
          className={`brand-menu-trigger brand-desktop-hidden hamburger hamburger--spin ${
            menuOpen === true ? `is-active` : ``
          }`}
          type="button"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span className="hamburger-box">
            <span className="hamburger-inner" />
          </span>
        </button>
        <div
          className={`brand-menu ${menuOpen === true && 'brand-menu-open'}`}
          id="brandMenu"
          ref={navRef}
          onClick={() => setMenuOpen(!menuOpen)}
          role="navigation"
        >
          <div className={`brand-menu-items brand-background-${background}`}>
            <Link
              to="/our-story/"
              className="brand-nav-item"
              activeClassName="active"
              partiallyActive={true}
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <span className="brand-nav-number">01</span>
              Our Story
            </Link>

            <Link
              to="/our-people/"
              className="brand-nav-item"
              activeClassName="active"
              partiallyActive={true}
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <span className="brand-nav-number">02</span>
              Our People
            </Link>

            <Link
              to="/our-games/"
              className="brand-nav-item"
              activeClassName="active"
              partiallyActive={true}
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <span className="brand-nav-number">03</span>
              Our Games
            </Link>

            <Link
              to="/news/"
              className="brand-nav-item"
              activeClassName="active"
              partiallyActive={true}
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <span className="brand-nav-number">04</span>
              News
            </Link>

            <Link
              to="/careers/"
              className="brand-nav-item"
              activeClassName="active"
              partiallyActive={true}
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <span className="brand-nav-number">05</span>
              Careers
            </Link>

            <Link
              to="/contact-us/"
              className="brand-nav-item"
              activeClassName="active"
              partiallyActive={true}
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <span className="brand-nav-number">06</span>
              Contact Us
            </Link>
          </div>
          <img
            src={ColorSwitcher(background).top}
            className="brand-slash-menu w-100 brand-desktop-hidden"
            alt=""
          />
        </div>
      </nav>
    </header>
  );
};

export default Header;

// ====

Header.propTypes = {
  settings: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Header.defaultProps = {
  settings: null,
};
